import { isNil } from 'lodash-es';
import { OneServiceNoParams, OneServiceWithParams } from 'types/services/services';

/**
 * Create Tanstack query key from a service without params.
 * @param service service without params
 * @return Tanstack query key
 */
function serviceToTQKey<Data>(service: OneServiceNoParams<Data>): readonly [string];
/**
 * Create Tanstack query key from a service with params.
 * @param service service with params
 * @param params params for the service
 * @returns Tanstack query key
 */
function serviceToTQKey<Data, Params extends object>(service: OneServiceWithParams<Data, Params>, params: Params): readonly [string, Params];
/**
 * Create Tanstack query key from a service
 * @param service  service
 * @param params params for the service
 * @returns Tanstack query key
 */
function serviceToTQKey<Data, Params extends object>(
  service: Params extends object ? OneServiceWithParams<Data, Params> : OneServiceNoParams<Data>,
  params?: Params,
): readonly [string] | readonly [string, Params] {
  // unique key of the service
  const key = `${service.serviceId}/${service.id}`;

  if (isNil(params)) {
    // no params
    return [key];
  }

  // add the params
  return [key, params];
}

export default serviceToTQKey;
